import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import React from "react";
import Login from "./pages/Authentication/Login";
import Registration from "./pages/Authentication/Registration";
import Verification from "./pages/Authentication/Verification";
import ResetPassword from "./pages/Authentication/ResetPassword";
import ForgotPassword from "./pages/Authentication/ForgotPassword";
import Home from "./pages/Home/Home";
import Documentation from "./pages/Documentation/Documentation";
import Datasets from "./pages/Datasets/Datasets";
import DemoMasterMetaData from "./pages/Datasets/MetaData";
import CreateChart from "./pages/Charts/CreateChart";
import GeneratedChart from "./pages/Charts/GeneratedChart";
import EditChartPage from "./pages/Charts/EditChartPage";
import SingleDashboard from "./pages/Dashboards/SingleDashboard";
import Recommendations from "./pages/Recommendations/Recommendations";
import SettingsPage from "./pages/Settings/SettingsPage";
import AuthRoute from "./components/Forms/AuthForms/AuthRoute";
import "./i18n";
import ReportBugPage from "./pages/Settings/ReportBugPage";
import HomePage from "./pages/Home/HomePage";

function AppWrapper() {
  const location = useLocation();
  const publicPaths = [
    "/",
    "/register",
    "/forgot-pass",
    "/verify",
    "/reset-password"
  ];

  const isPublicPage = publicPaths.includes(location.pathname);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/forgot-pass" element={<ForgotPassword />} />
        <Route path="/verify" element={<Verification />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* <Route path="/report-bug" element={<ReportBugPage />} /> */}
        <Route path="/home" element={<AuthRoute><Home /></AuthRoute>} />
        <Route path="/documentation" element={<AuthRoute><Documentation /></AuthRoute>} />
        <Route path="/home-page" element={<AuthRoute><HomePage /></AuthRoute>} />
        <Route path="/datasets" element={<AuthRoute><Datasets /></AuthRoute>} />
        <Route path="/meta-data" element={<AuthRoute><DemoMasterMetaData /></AuthRoute>} />
        <Route path="/create-chart" element={<AuthRoute><CreateChart /></AuthRoute>} />
        <Route path="/single-dashboard" element={<AuthRoute><SingleDashboard /></AuthRoute>} />
        <Route path="/generated-chart" element={<AuthRoute><GeneratedChart /></AuthRoute>} />
        <Route path="/recommendations" element={<AuthRoute><Recommendations /></AuthRoute>} />
        <Route path="/settings" element={<AuthRoute><SettingsPage /></AuthRoute>} />
        <Route path="/edit-chart" element={<AuthRoute><EditChartPage /></AuthRoute>} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  );
}

export default App;
